import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/useAuthStore";
import BottomNav from "@/layout/BottomNav";

export default function ProtectedRoute() {
  const accessToken = useAuthStore((s) => s.accessToken);
  return accessToken ? (
    <>
      <Outlet />
      <BottomNav />
    </>
  ) : (
    <Navigate to="/login" replace />
  );
}
